import React from "react";

const NotFoundPage = () => {
  window.location.href = "https://home.moti.bio/404";
  return <div></div>;
};

export default NotFoundPage;
